/**
 * Scorecard Tab Wrapper
 * Wrapper component to be used in InterviewTabs
 * Handles feature flag and visibility mode switching
 */

import React from 'react';
import { ScorecardWithVisibility } from './ScorecardWithVisibility';
import { AfterInterviewScorecard } from '../../AfterInterviewScorecard';
import { GroupedScorecards, ScorecardVisibilityMode } from '../types';
import { useKFlags } from '@/hooks/use-k-flags';
import { InterviewType } from '@/pages/interviews-revamp/types/interview';

interface ScorecardTabWrapperProps {
  interview: InterviewType;
  interviewId?: string | number;
  scorecardVisibilityMode?: ScorecardVisibilityMode;
  apiGroupedScorecards?: GroupedScorecards;
  hasCurrentUserSubmitted: boolean;
  tabId: string;
  refetchScorecardVisibility: () => void;
}

export const ScorecardTabWrapper = React.memo(function ScorecardTabWrapper({
  interview,
  apiGroupedScorecards,
  scorecardVisibilityMode,
  hasCurrentUserSubmitted,
  tabId,
  refetchScorecardVisibility,
}: ScorecardTabWrapperProps) {
  const { feScorecardVisibility } = useKFlags();
  const visibilityMode: ScorecardVisibilityMode =
    scorecardVisibilityMode || 'never';

  // If feature is disabled, use the original component
  if (!feScorecardVisibility) {
    return <AfterInterviewScorecard interview={interview} />;
  }

  // Use new visibility-aware component
  // this has the logic for showing the scorecard based on the visibility mode
  return (
    <ScorecardWithVisibility
      interview={interview}
      apiGroupedScorecards={apiGroupedScorecards}
      visibilityMode={visibilityMode}
      hasCurrentUserSubmitted={hasCurrentUserSubmitted}
      tabId={tabId}
      refetchScorecardVisibility={refetchScorecardVisibility}
    />
  );
});
